module.exports = __webpack_public_path__ + "static/media/mbSaltSprayTestingChamber.344944de.jpg";